/**
 * Prebuilt voice names for Gemini Live native audio.
 * https://cloud.google.com/vertex-ai/generative-ai/docs/live-api/configure-language-voice
 * Keys must match API prebuiltVoiceConfig.voiceName exactly.
 */
export const GEMINI_LIVE_DEFAULT_VOICE = 'Aoede';

/** @type {Record<string, { gender: 'female'|'male'|'neutral', description: string }>} */
export const GEMINI_LIVE_PREBUILT_VOICES = {
  Achernar: { gender: 'male', description: 'Soft, calm' },
  Achird: { gender: 'male', description: 'Friendly, warm' },
  Algenib: { gender: 'male', description: 'Gravelly, dynamic' },
  Algieba: { gender: 'male', description: 'Smooth, warm' },
  Alnilam: { gender: 'male', description: 'Firm, professional' },
  Aoede: { gender: 'female', description: 'Breezy, light' },
  Autonoe: { gender: 'female', description: 'Bright, eager' },
  Callirrhoe: { gender: 'female', description: 'Easy-going, friendly' },
  Charon: { gender: 'male', description: 'Deep, informative' },
  Despina: { gender: 'female', description: 'Smooth, reassuring' },
  Enceladus: { gender: 'male', description: 'Breathy, dynamic' },
  Erinome: { gender: 'female', description: 'Clear, professional' },
  Fenrir: { gender: 'male', description: 'Excitable, intense' },
  Gacrux: { gender: 'female', description: 'Mature, grounded' },
  Iapetus: { gender: 'male', description: 'Clear, professional' },
  Kore: { gender: 'female', description: 'Firm, professional' },
  Laomedeia: { gender: 'female', description: 'Upbeat, inquisitive' },
  Leda: { gender: 'female', description: 'Youthful, bright' },
  Orus: { gender: 'male', description: 'Firm, serious' },
  Puck: { gender: 'male', description: 'Upbeat, playful' },
  Pulcherrima: { gender: 'female', description: 'Forward, confident' },
  Rasalgethi: { gender: 'male', description: 'Informative, professional' },
  Sadachbia: { gender: 'male', description: 'Lively, energetic' },
  Sadaltager: { gender: 'male', description: 'Knowledgeable, warm' },
  Schedar: { gender: 'male', description: 'Even, measured' },
  Sulafat: { gender: 'female', description: 'Warm, approachable' },
  Umbriel: { gender: 'male', description: 'Easy-going, casual' },
  Vindemiatrix: { gender: 'female', description: 'Gentle, thoughtful' },
  Zephyr: { gender: 'female', description: 'Bright, energetic' },
  Zubenelgenubi: { gender: 'male', description: 'Casual, friendly' },
};
